import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { InputCheckboxComponent } from './input-checkbox.component';
import {NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgSelectModule,
    FormsModule,
    NgbTooltipModule
  ],
  declarations: [InputCheckboxComponent],
  exports: [InputCheckboxComponent]
})
export class InputCheckboxModule {
}
